export enum ChatApplicationUpdateType {
    APPLIED = 0,
    VIEWED = 1,
    UNLOCKED = 2,
    JOB_CLOSED = 3,
    SHORT_LISTED = 4,
    NOT_SELECTED = 5,
    INVITATION_SENT = 6,
    INVITATION_RESPONSE = 7
}